import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeBanner from '../../component/slidercomponent/SliderHomeBanner';


const HomeBanner = () => {
    return (
        <>

            <section className="hero-section hero-1 hero-bg fix">
                <div className="perasute-shape float-bob-y">
                    <img src="assets/img/hero/perashute.png" alt="shape-img" />
                </div>
                <div className="car-shape float-bob-x">
                    <img src="assets/img/hero/car.png" alt="shape-img" />
                </div>
                <div className="tree-shape">
                    <img src="assets/img/hero/tree.png" alt="shape-img" />
                </div>
                <div className="crown-shape">
                    <img src="assets/img/hero/crown.png" alt="shape-img" />
                </div>
                <div className="frame-shape float-bob-y">
                    <img src="assets/img/hero/frame.png" alt="shape-img" />
                </div>
                <div className="line-shape">
                    <img src="assets/img/hero/hero-line.png" alt />
                </div>
                <div className="container hero-container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-5">
                            <div className="hero-content">
                                <h1 className="char-animation">A Happy Place to Grow, Play And Learn</h1>
                                <p className="wow fadeInUp" data-wow-delay=".3s">Sudarshan Academy is an early childhood educational
                                    environment where most young for your children life.</p>
                                <div className="hero-button wow fadeInUp" data-wow-delay=".5s">
                                    <Link to="/contact" className="theme-btn">Admission Open <i className="icon-arrow-icon" /></Link>
                                    <div className="wave-area">
                                        <div className="promo-video">
                                            <div className="waves-block">
                                                <div className="waves wave-1" />
                                                <div className="waves wave-2" />
                                                <div className="waves wave-3" />
                                            </div>
                                            <Link className="video-popup" to="https://www.youtube.com/@sudarshanpublicschool5741" target="_blank">
                                                <i className="fas fa-play" />
                                            </Link>
                                        </div>
                                        <p className="video-text">Paly YouTube Video</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                            <div className="hero-img">
                                <img src="assets/img/hero/hero1.png" alt="hero-img" />
                                <div className="text-shape float-bob-y">
                                    <img src="assets/img/hero/text.png" alt="shape-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeBanner